const TruncateDecimals = (value, decimals = 2) => {
    if (typeof value !== 'number' || isNaN(value)) return value;

    const factor = 10 ** decimals;
    return (Math.trunc(value * factor) / factor).toFixed(decimals);
};

export default TruncateDecimals;
